var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotFlightPath = function SvgHotspotFlightPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M6.285 18.17V7.47a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v9.391a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6.17"
  })));
};
export default SvgHotspotFlightPath;